export const componentFamily = {
    // html family
    Button: 'html',
    ButtonLink: 'html',
    Card: 'html',
    Chip: 'html',
    Note: 'html',
    Header1: 'html',
    Header5: 'html',
    MessageCard: 'html',
    Banner: 'html',
    ClosableBanner: 'html',
    FlashMessage: 'html',
    Menu: 'html',
    MenuItem: 'html',
    Modal: 'html',
    ModalCloseButton: 'html',
    ModalWithPortal: 'html',
    Overlay: 'html',
    Table: 'html',
    TableHead: 'html',
    TableBody: 'html',
    TableRow: 'html',
    TableCell: 'html',
    Tag: 'html',
    CollapsibleLink: 'html',
    LifullConnectLogo: 'html',
    MitulaGroupLogo: 'html',
    MitulaLogo: 'html',
    NestoriaLogo: 'html',
    NuroaLogo: 'html',
    ThribeeFavicon: 'html',
    ThribeeLogo: 'html',
    TrovitLogo: 'html',
    Checkbox: 'html',
    OptionInput: 'html',
    Radio: 'html',
    Switch: 'html',
    // mui4 family
    TextInput: 'mui4',
    Select: 'mui4',
    SelectOption: 'mui4',
    SingleSelect: 'mui4',
    MultipleSelect: 'mui4',
    CurrencyInput: 'mui4',
    DatePicker: 'mui4',
    Slider: 'mui4',
    TagsInput: 'mui4',
    Suggester: 'mui4',
    ImprovedSuggester: 'mui4',
    Tabs: 'mui4',
    Tab: 'mui4',
    Tooltip: 'mui4',
};
